import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  getSelectedCloverDevices,
  saveSelectedCloverDevices,
} from 'utils/storage';

import { SelectedDevice, CloverDeviceState } from './types';

const initialState: CloverDeviceState = {
  selectedDevices: getSelectedCloverDevices(),
};

const cloverDeviceSlice = createSlice({
  initialState,
  name: 'cloverDevice',
  reducers: {
    clearAllSelectedDevices: (state) => {
      state.selectedDevices = {};
      saveSelectedCloverDevices({});
    },
    clearSelectedDevice: (state, action: PayloadAction<number>) => {
      delete state.selectedDevices[action.payload];
      saveSelectedCloverDevices(state.selectedDevices);
    },
    setSelectedDevice: (state, action: PayloadAction<SelectedDevice>) => {
      const { eventId, deviceId } = action.payload;
      state.selectedDevices[eventId] = deviceId;
      saveSelectedCloverDevices(state.selectedDevices);
    },
  },
});

const {
  reducer: cloverDeviceReducer,
  actions: { setSelectedDevice, clearSelectedDevice, clearAllSelectedDevices },
} = cloverDeviceSlice;

export {
  setSelectedDevice,
  cloverDeviceReducer,
  clearSelectedDevice,
  clearAllSelectedDevices,
};

export * from './selectors';
